export { default } from './ScoredTableError'
